import ActiveAppointmentsBanner from './ActiveAppointmentsBanner';
export default ActiveAppointmentsBanner;
